import { Input, type InputProps } from "antd";
import { formatUzPhoneInput, normalizeUzPhoneInput } from "@/shared/utils/uz-phone";

type UzPhoneInputProps = Omit<InputProps, "onChange" | "value"> & {
	onChange: (value: string) => void;
	value: string;
};

export function UzPhoneInput({
	onChange,
	placeholder = "90 123 45 67",
	value,
	...props
}: UzPhoneInputProps) {
	return (
		<Input
			{...props}
			addonBefore="+998"
			inputMode="numeric"
			placeholder={placeholder}
			value={formatUzPhoneInput(value)}
			onChange={(event) => onChange(normalizeUzPhoneInput(event.target.value))}
		/>
	);
}

export default UzPhoneInput;
